import _slicedToArray from "/mnt/c/onesaz/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { unpack } from '../../utils/index.js';
var hsl2rgb = function hsl2rgb() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args = unpack(args, 'hsl');
  var _args = args,
    _args2 = _slicedToArray(_args, 3),
    h = _args2[0],
    s = _args2[1],
    l = _args2[2];
  var r, g, b;
  if (s === 0) {
    r = g = b = l * 255;
  } else {
    var t3 = [0, 0, 0];
    var c = [0, 0, 0];
    var t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var t1 = 2 * l - t2;
    var h_ = h / 360;
    t3[0] = h_ + 1 / 3;
    t3[1] = h_;
    t3[2] = h_ - 1 / 3;
    for (var i = 0; i < 3; i++) {
      if (t3[i] < 0) t3[i] += 1;
      if (t3[i] > 1) t3[i] -= 1;
      if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];else if (2 * t3[i] < 1) c[i] = t2;else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;else c[i] = t1;
    }
    r = c[0] * 255;
    g = c[1] * 255;
    b = c[2] * 255;
  }
  if (args.length > 3) {
    // keep alpha channel
    return [r, g, b, args[3]];
  }
  return [r, g, b, 1];
};
export default hsl2rgb;